import { QueryParametersState } from "@idw-types/state";
import fetch from "cross-fetch";

export const getVerificationConfiguration = (queryParameters: QueryParametersState): Promise<Response> => {   
    const route = `${queryParameters.apiUrl}/axn/doc/config?_cb=${new Date().getTime()}&newResponse=t`;
    const request = {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ token: queryParameters.token }),
        method: "POST"
    };
    return fetch(route, request);
};